import { z } from 'zod';

export const TenantSchema = z.object({
  id: z.string().uuid(),
  name: z.string().min(1).max(200),
  piva: z.string().regex(/^\d{11}$/).optional(),
  codice_fiscale: z.string().optional(),
  created_at: z.string().datetime(),
  archived_at: z.string().datetime().nullable(),
  last_rev: z.number().int().nonnegative().default(0),
  settings: z.record(z.unknown()).default({}),
  // T-130: se true l'editor ricette chiede qty/uom; se false le nasconde.
  // warehouse_enabled=true lo forza true (trigger DB).
  recipe_quantities_enabled: z.boolean().default(false),
  // T-285 (Food Cost): se true abilita il modulo Food Cost. Cambiabile solo da
  // owner/consulente (guard JWT). Forza recipe_quantities_enabled=true (trigger DB).
  food_cost_enabled: z.boolean().default(false),
  // T-473: preventivi eventi/sale è acquistabile e utilizzabile indipendentemente
  // dal Food Cost ristorante. Default off preserva tutti i tenant esistenti.
  event_quotes_enabled: z.boolean().default(false),
  // T-562: acquisizione fotografica dei lotti durante produzione/ricetta.
  // Feature volontaria: default off preserva il workflow esistente.
  production_lot_photo_enabled: z.boolean().default(false),
  // T-563: DDT in uscita e trasferimenti interni, indipendenti dalla Collettiva.
  transport_documents_enabled: z.boolean().default(false),
  // T-291: se true, al ricevimento merci si registra la temperatura per articolo
  // (oltre al flag conformità generico). Preferenza di workflow, non feature a
  // pagamento: nessun guard, impostabile dai membri dalle Impostazioni. Default false.
  receiving_temp_per_item: z.boolean().default(false),
});
export type Tenant = z.infer<typeof TenantSchema>;

export const BusinessSchema = z.object({
  id: z.string().uuid(),
  tenant_id: z.string().uuid(),
  name: z.string().min(1).max(200),
  address: z.string().optional(),
  city: z.string().optional(),
  cap: z.string().regex(/^\d{5}$/).optional(),
  provincia: z.string().length(2).optional(),
  // T-341: config per-sede dei giorni in cui spuntano i cassetti pulizie
  // settimanale (1=Lun..7=Dom ISO) e mensile (1..31). Nullable: assente =
  // comportamento legacy (cassetto sempre visibile).
  cleaning_weekly_weekday: z.number().int().min(1).max(7).nullable().optional(),
  cleaning_monthly_day: z.number().int().min(1).max(31).nullable().optional(),
  created_at: z.string().datetime(),
  archived_at: z.string().datetime().nullable(),
  version: z.number().int().nonnegative().default(0),
});
export type Business = z.infer<typeof BusinessSchema>;
